<nav class="site-menu" [class.menu-dismiss]="dismissed" (click)="onMenuClick($event)" (mouseleave)="dismissed=false">
  <ul>
    <li [ngClass]="{'active':pMenu.active}" *ngFor="let pMenu of menuService.items">
      <a [routerLink]='pMenu.route' routerLinkActive="active">
        <span><i class="fa fa-{{iconFor(pMenu)}} fa-2x"></i>{{pMenu.text | translate}}</span>
      </a>
      <ul class="sub-menu" *ngIf="pMenu.submenu && !pMenu.megamenu">
        <li [ngClass]="{'has-children': cMenu.submenu}" routerLinkActive='active' *ngFor="let cMenu of pMenu.submenu">
          <a routerLink="/app/{{cMenu.route}}" routerLinkActive="active">
            <i class="fa fa-{{iconFor(cMenu)}} menu-ico" aria-hidden="true"></i>
            <span style="font-weight:bold">{{cMenu.text | translate}}</span>
          </a>
        </li>
      </ul>
      <!-- Panels only render when a submenu exists (home has none - the old
           else-template rendered an EMPTY mega panel shell on hover). -->
      <mega-menu class="mega-menu" *ngIf="pMenu.submenu && pMenu.megamenu" [smenus]="pMenu.submenu"></mega-menu>
    </li>
    <!--  <form autocomplete="off"  class="search-form mb-2" method="get" style="display:none">
      <input type="search" placeholder="{{'Type'|translate}} search query">
      <i class="material-icons search"></i>
    </form> -->
  </ul>
</nav>
